import { boundingRect, buildParentMap, setWorldBox, tidyLayout, worldBox } from "@cva/shared";
import type { EditorStore } from "./store";

/** Minimum number of elements for "Aufräumen". */
export const TIDY_MIN = 3;

export function canTidy(store: EditorStore): boolean {
  const { selection, doc, readOnly } = store.getState();
  return !readOnly && selection.filter((id) => !doc.elements[id]?.locked).length >= TIDY_MIN;
}

/**
 * "Aufräumen": the selected elements as a tidy row, column or grid with equal
 * gaps inside their current bounding box (scene/tidy.ts), one undo step.
 */
export function tidySelection(store: EditorStore) {
  const { selection, doc } = store.getState();
  const ids = selection.filter((id) => !doc.elements[id]?.locked);
  if (ids.length < TIDY_MIN) return;
  store.getState().update((draft) => {
    const parents = buildParentMap(draft);
    const items = ids.flatMap((id) => {
      const box = worldBox(draft, id, parents);
      return box ? [{ id, box, rect: boundingRect(box) }] : [];
    });
    const layout = tidyLayout(items);
    for (const item of items) {
      const target = layout.get(item.id);
      if (!target) continue;
      setWorldBox(draft, item.id, {
        ...item.box,
        x: item.box.x + (target.x - item.rect.x),
        y: item.box.y + (target.y - item.rect.y),
      });
    }
  });
}
